import { CognitoUserPool, AuthenticationDetails, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import userpoolconfig from '@/userpoolconfig'
import { getUserPool, getStoredSession, getUnauthorizedUser } from './../../../utils/cognito'
// import api from './../../../utils/mock-api'
import api from './../../../utils/api'
import types from './types';

const toUsername = (email) => {
  return email.replace('@', '-at-');
}

export default {
  authRequest ({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('authRequest')

      const authenticationData = {
        Username: payload.email,
        Password: payload.password,
      };

      const authenticationDetails = new AuthenticationDetails(authenticationData);

      const poolData = userpoolconfig.cognito;
      const userPool = new CognitoUserPool(poolData);

      const userData = {
        Username: payload.email.replace('@', '-at-'),
        Pool: userPool
      }
      const cognitoUser = new CognitoUser(userData);

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          console.log('login success')
          console.dir(result)
          commit('authSuccess', result)
          resolve()
        },
        onFailure: (err) => {
          console.log(err.message || JSON.stringify(err))
          commit('authError')
          reject(err)
        }
      })
    })
  },
  authLogout ({commit}) {
    return new Promise((resolve, reject) => {
      commit('authLogout')
      const poolData = userpoolconfig.cognito;
      const userPool = new CognitoUserPool(poolData);
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser) {
        cognitoUser.signOut();
      }
      resolve()
    })
  },
  authRefresh ({commit}) {
    return new Promise((resolve, reject) => {
      console.log('authRefresh');
      const poolData = userpoolconfig.cognito;
      const userPool = new CognitoUserPool(poolData);
      const cognitoUser = userPool.getCurrentUser();
      cognitoUser.getSession((err, result) => {
        if (err) {
          console.log('auth refresh error');
          commit('authError')
          reject(err);
        } else {
          console.log('auth refresh success');
          commit('authSuccess', result)
          resolve();
        }
      });
    })
  },
  [types.actions.REGISTER_USER] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(types.mutations.REGISTERING_USER);
      const userPool = getUserPool();

      const email = payload.email;
      const password = payload.password;
      const name = payload.name;
      const code = payload.code;

      const dataEmail = {
        Name: 'email',
        Value: email
      };

      const dataName = {
        Name: 'name',
        Value: name
      };

      const dataValidationCode = {
        Name: 'code',
        Value: code
      };

      const attributeEmail = new CognitoUserAttribute(dataEmail);
      const attributeName = new CognitoUserAttribute(dataName);
      const attributeValidationCode = new CognitoUserAttribute(dataValidationCode);

      const attributes = [attributeEmail, attributeName];
      const validationData = [attributeValidationCode];

      userPool.signUp(toUsername(email), password, attributes, validationData,
        function (err, result) {
          if (err) {
            console.log(err.message || JSON.stringify(err));
            commit(types.mutations.REGISTERING_USER_FAILED);
            reject(err);
            // alert(err.message || JSON.stringify(err));
          } else {
            commit(types.mutations.USER_REGISTERED);
            resolve(result);
          }
        }
      );
    });
  },
  authVerify ({commit}, payload) {
    return new Promise((resolve, reject) => {
      const poolData = userpoolconfig.cognito;
      const userPool = new CognitoUserPool(poolData);

      const userData = {
        Username: payload.username,
        Pool: userPool
      }

      const cognitoUser = new CognitoUser(userData);

      cognitoUser.confirmRegistration(payload.code, true, function (err, result) {
        if (err) {
          console.log('authVerify confirm error');
          console.dir(err);
          reject(err);
          return;
        }
        console.log('authVerify result');
        console.dir(result);
        resolve();
      });
    })
  },
  async [types.actions.GENERATE_CODES] ({commit}, payload) {
    try {
      commit(types.mutations.GENERATING_CODES)
      const amount = payload.amount || 1;
      const permissions = payload.permissions;
      const response = await api.generateCodes({amount, permissions});
      if (response && response.data) {
        commit(types.mutations.RECEIVE_CODES, response.data)
      }
    } catch (err) {
      commit(types.mutations.CODE_GENERATION_ERROR, err)
    }
  },
  async [types.actions.CODE_USED] ({commit}, code) {
    try {
      await api.codeUsed(code);
    } catch (err) {
      throw new Error({message: 'Error removing used code.', error: err});
    }
  },
  [types.actions.RESEND_VERIFICATION] ({commit}, email) {
    return new Promise((resolve, reject) => {
      const userPool = getUserPool();

      const userData = {
        Username: toUsername(email),
        Pool: userPool
      }

      const cognitoUser = new CognitoUser(userData);

      cognitoUser.resendConfirmationCode(function (err, result) {
        if (err) {
          console.log('authResend confirm error');
          console.dir(err);
          reject(err);
          return;
        }
        console.log('authResend result');
        console.dir(result);
        resolve();
      });
    })
  },
  [types.actions.CHANGE_PASSWORD] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      const user = getUserPool().getCurrentUser();
      user.getSession((err, res) => {
        if (err) {
          return;
        }
        const password = payload.password;
        const newPassword = payload.newPassword;

        user.changePassword(password, newPassword, function (err, result) {
          if (err) {
            console.log(err);
            reject(err);
            return;
          }
          resolve();
        });
      });
    })
  },
  [types.actions.CONFIRM_PASSWORD_CHANGE] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      const email = payload.email;
      const verificationCode = payload.code;
      const newPassword = payload.newPassword;

      const user = getUnauthorizedUser(toUsername(email));
      user.confirmPassword(verificationCode, newPassword, {
        onSuccess: function () {
          resolve();
        },
        onFailure: function (err) {
          reject(err);
        }
      });
    })
  },
  [types.actions.FORGOT_PASSWORD] ({commit}, payload) {
    return new Promise((resolve, reject) => {
      const email = payload.email;
      const user = getUnauthorizedUser(toUsername(email));
      user.forgotPassword({
        onSuccess: function () {
          resolve();
        },
        onFailure: function (err) {
          reject(err);
        }
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js